
<template>
  <ItemsWaiting style="position: absolute;right: -1vw !important;top: 3vw;z-index: -1;" v-if="is_fetch" />
  <div v-else>
    <div v-show="AllItemList.length" class="d-flex justify-content-between">
      <div class="text-right m-4">
        <h5 style="font-size: 1vw !important">       </h5>
      </div>
      <div v-if="AllItemList.length" class="d-flex">
        <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1" v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true">   دلایل عدم تایید</a>


        <!--      <a v-if="false" :href="`${this.download_url}/Definition_of_basic_measures/all/pdf/by/id/${id_user}?token=${$cookies.get('id_login')}`"
                 style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1" v-show="false" >خروجی
                PDF
              </a>-->


      </div>

    </div>
    <center v-if="status_approver">
      <div   class="alert alert-success w-25">
        تایید نهایی!
      </div>
    </center>
    <center v-if="!status_show && AllItemList.length">

      <div v-if="seconder_ban"  class="alert alert-warning w-50" @click="infoCancelledModal=true" >
        <div v-if="this.type==='producer'">
          کاربرگ توسط مدیر عامل ؛ تایید نشد!
        </div>
        <div v-else>
          این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!

        </div>
      </div>
    </center>
    <center v-if="!status_show">
      <div v-if="approver_ban" @click="infoCancelledModal=true"  class="alert alert-info" style="width: 30vw;">
        کاربرگ توسط دبیر کمسیون بهره وری ؛ تایید نشد!
      </div>
    </center>
    <center   v-if="status_seconder_step">
      <div v-if="status_seconder" class="alert alert-info w-25">
        در انتظار تایید توسط مدیر عامل
      </div>
      <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
        در انتظار تایید توسط دبیر کمسیون بهره وری
      </div>
    </center>
    <div class="d-flex justify-content-start m-3" v-if="show_insert&& not_show && data_entry">
      <div class="d-flex flex-column" style="width: 80vw;">
        <label class="required">  عنوان اقدام</label>
        <input v-model="title" type="text" class="form-control">
      </div>



    </div>

    <div class="d-flex justify-content-start m-3" v-if="show_insert&& not_show && data_entry">

      <div class="d-flex flex-column  align-items-center" style="width: 25vw;">
        <label > همسوسازی و ایجاد انگیزه برای متولیان بهره‌وری  </label>
        <input :checked="alignment_and_motivation"  v-model="alignment_and_motivation" type="checkbox" class="form-check">
      </div>
      <div class="d-flex flex-column mx-2 align-items-center" style="width: 25vw;">
        <label class="">  همراه‌سازی و هم‌افزایی بازیگران کلیدی </label>
        <input :checked="accompanying_and_synergy" v-model="accompanying_and_synergy" type="checkbox" class="form-check">
      </div>
      <div class="d-flex flex-column mx-2 align-items-center" style="width: 25vw;">
        <label class="">  تبیین و گفتمان‌سازی عمومی </label>
        <input :checked="explanation_and_discussion" v-model="explanation_and_discussion" type="checkbox" class="form-check">
      </div>
    </div>
    <div class="d-flex justify-content-between m-3" v-if="show_insert && data_entry && not_show">
      <div class="d-flex flex-column">
        <label class="required">  توضیحات </label>
        <textarea v-model="text" name="" class="form-control" id="" cols="30" rows="30"></textarea>
      </div>
      <div class="d-flex flex-column">
        <label class="required">  زمان شروع   اقدام </label>
        <Vue3PersianDatetimePicker v-model="start_date"></Vue3PersianDatetimePicker>
      </div>
      <div class="d-flex flex-column">
        <label class="required">  زمان پایان   اقدام </label>
        <Vue3PersianDatetimePicker v-model="end_date"></Vue3PersianDatetimePicker>

      </div>
      <div class="d-flex flex-column">
        <label class="required">  دستگاه متولی </label>
        <input v-model="trustee_device" type="text" class="form-control">
      </div>


    </div>
    <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-show="documentsModal">
      <div class="d-flex justify-content-between">
        <p>{{titleDoc}}</p>
       <p @click="documentsModal = !documentsModal; documents = []">❌</p>

      </div>
      <hr class="mb-3">
      <div class="d-flex flex-column" v-if="show_insert && data_entry && not_show">
        <label class="required">     عنوان مستندات پیوست  </label>
        <input v-model="title_attach" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column" v-if="show_insert && data_entry && not_show">
        <label class="required">      فایل   پیوست  </label>
        <input   type="file" class="form-control" style="display:block;"  ref="fileInput">
      </div>
      <center class="my-2" v-if="show_insert && data_entry && not_show">
        <button @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
      </center>
      <hr class="my-3 w-100  " v-if="show_insert && data_entry && not_show">
      <table v-if="documents.length" class="table table-striped bg-white">

        <tbody>
        <tr>
          <th ><strong> عنوان مستند    </strong></th>
          <th><strong>فایل مستند</strong></th>
          <th v-if="show_insert && data_entry && not_show" style="width: 1vw;">عملیات</th>
        </tr>
        <tr v-for="(item) in documents">
          <td>{{item.title}}</td>
          <td>
            <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
          </td>
          <td v-if="show_insert && data_entry && not_show">
            <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
          </td>
        </tr>
        </tbody>


      </table>

      <span v-else >فایلی یافت نشد</span>

    </div>
    <div class="d-flex justify-content-between m-3" v-if="show_insert && data_entry && not_show">

      <div class="d-flex align-items-end" >
        <div class="d-flex flex-column align-items-center" style="width: 25vw;">
          <label class="required">  پیشرفت مورد انتظار فعالیت در پایان سال (%)   </label>
          <input v-model="progress" type="number" class="form-control" style="width: 4vw;">

        </div>

      </div>
      <button v-if="!is_update" @click.prevent="store" class="btn btn-submit-1 btn-primary my-3" style="font-size: 1vw;">ذخیره </button>

      <div class="d-flex align-items-center justify-content-center" v-else>
        <button  @click.prevent="update(id_item)" style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ویرایش</button>
        <Reset @click.prevent="resetItems" style="width: 1.5vw; height: 1.5vw; transform: translateY(0.5vw); cursor: pointer; margin-right: 1vw;" />
      </div>

    </div>


    <div class="table-responsive p-5" style="  transform: translateX(2.5vw); overflow-x: hidden; width: 80vw;">
      <center v-show="!AllItemList.length">
        <hr v-if="isWrite" class="w-75 my-3">

        <span v-if="type==='producer' && isWrite">اقدام اساسی وجود ندارد</span>
        <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
        <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
      </center>
      <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table v-show="AllItemList.length && isWrite" class="table table-striped"    >
          <tbody>
          <tr>
            <th colspan="14"><strong>  اقدامات پشتیبان    </strong></th>

          </tr>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>
            <th style="width: 60vw;" rowspan="2"><strong>
              عنوان اقدام
            </strong></th>
            <th colspan="3"><strong> نوع اقدام  </strong></th>
            <th rowspan="2"><strong>توضیحات</strong></th>
            <th rowspan="2"><strong>دستگاه متولی</strong></th>
            <th rowspan="2"><strong>زمان شروع   اقدام</strong></th>
            <th rowspan="2"><strong>زمان  پایان اقدام</strong></th>
            <th rowspan="2"><strong>پیشرفت مورد انتظار فعالیت در پایان سال (%)</strong></th>
            <th rowspan="2"><strong>مستندات</strong></th>
            <th v-if="show_insert && data_entry && not_show" rowspan="2"><strong>عملیات</strong></th>

          </tr>
          <tr>

            <th>همسوسازی و ایجاد انگیزه برای متولیان بهره‌وری  </th>
            <th>همراه‌سازی و هم‌افزایی بازیگران کلیدی</th>
            <th>تبیین  و گفتمان‌سازی عمومی</th>
          </tr>
          <tr class="bg-white" v-for="(item, index) in AllItemList">
            <td>{{index+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.alignment_and_motivation ? '✅' : ''}}</td>
            <td>{{item.accompanying_and_synergy ? '✅' : ''}}</td>
            <td>{{item.explanation_and_discussion ? '✅' : ''}}</td>
            <td>{{item.text}}</td>
            <td>{{item.trustee_device}}</td>
            <td>{{item.start_date}}</td>
            <td>{{item.end_date}}</td>
            <td>{{item.progress}}</td>
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <button @click="docsMethod(item.title, item.id)" class="btn btn-primary btn-submit-1">مشاهده </button>
              </div>
            </td>
            <td v-if="show_insert&& data_entry && not_show">
              <div class="d-flex justify-content-evenly">
                <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
                <a @click.prevent="deleteMethod(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
              </div>
            </td>


          </tr>


          </tbody>
        </table>

      </div>
      <br>
      <hr v-if="AllItemList.length">
      <div v-if="AllItemList.length" class="d-flex align-items-center justify-content-center">
        <a :href="`${this.download_url}/Definition_of_basic_measures/all/word/by/id/${id_user}?token=${$cookies.get('id_login')}`" style="margin-top: 1.3vw;margin-left: 1vw;"
           class="btn btn-primary btn-submit-1">خروجی Word</a>
        <a
            v-if="not_show"
            :style="type==='producer' ? 'width: 11vw': ''"
            style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green" class="btn btn-primary btn-submit-1 "


        >
          <div v-if="!status_loading">

            <span  @click="acceptComplete" v-if="type==='approver'">  تایید </span>
            <span style="font-size: 0.9vw;"  @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیرعامل</span>

          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>

        <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal" style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>اخطار</p>
            <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
          </div>
          <div>
            <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
              <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
            </div>
          </div>
        </div>
        <a v-if="type==='approver'&& not_show"   style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
           @click="acceptComplete2"
        >
          <div v-if="!status_loading2">
            <span >عدم تایید</span>
          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
      </div>
    </div>

    <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
      <div class="d-flex justify-content-between w-100">
        <p>حذف</p>
        <p @click="deleteModal=!deleteModal">❌</p>
      </div>
      <div>
        <p>آیا میخواهید حذف کنید!</p>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button class="btn btn-primary btn-approve" @click="deleteItemForm(id_item)">تایید</button>
        </div>
      </div>
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
      <div class="d-flex justify-content-between w-100">
        <p>حذف</p>
        <p @click="delete_fileModal=!delete_fileModal">❌</p>
      </div>
      <div>
        <p>آیا میخواهید حذف کنید!</p>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
        </div>
      </div>
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>عدم تایید</p>
        <p @click="infoCancelled=!infoCancelled">❌</p>
      </div>
      <div>
        <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
        <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
        </div>
      </div>
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>دلایل عدم تایید</p>
        <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
      </div>
      <div>
        <div class="bg-white p-3 rounded w-100 text-right">
          <p>{{textAlert}}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
        </div>
      </div>
    </div>

    <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
        <p @click="showReSubmit=!showReSubmit">❌</p>
      </div>
      <div>
        <div class="bg-white p-3 rounded w-100 text-right">
          <p>{{textAlert}}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button @click="acceptComplete4"  class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
        </div>
      </div>
    </div>
  </div>

</template>
<script >
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";
const toast = useToast();

export default {
  components:{ItemsWaiting, Reset, Vue3PersianDatetimePicker},
  data(){
    return{
      is_fetch: true,
      status_loading2: false,
      showReSubmit: false,
      acceptCompleteModal: false,
      data_entry:0,
      type:null,
      AllItemList: [],
      title: '',
      type: '',
      alignment_and_motivation: '',
      accompanying_and_synergy: '',
      explanation_and_discussion: '',
      text: '',
      title_attach: '',
      trustee_device: '',
      start_date: '',
      end_date: '',
      progress: '',
      documents: [],
      documentsModal: false,
      is_update: false,
      isWrite: false,
      deleteModal: false,
      titleDoc: '',
      id: '',
      id_user: '',
      id_item: '',
      id_file: '',
      delete_fileModal: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
      status_seconder: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      infoCancelledModal: false,
      status_seconder_step: false,

      not_show: true,

    }
  },
  methods:{
    setShow(){
      if (this.type==='producer'){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete(){
      this.acceptCompleteModal = false

      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban){
        this.showReSubmit=true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.allItems()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    acceptComplete4(){
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.allItems()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/support_measures_problems/update_complete`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.allItems()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/support_measures_problems/remove_docs/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title)
      formdata.append('type', this.type)
      formdata.append('alignment_and_motivation', this.alignment_and_motivation ? 1 : 0)
      formdata.append('accompanying_and_synergy', this.accompanying_and_synergy ? 1 : 0)
      formdata.append('explanation_and_discussion', this.explanation_and_discussion ? 1 : 0)
      formdata.append('text', this.text)
      formdata.append('title_attach', this.title_attach)
      formdata.append('trustee_device', this.trustee_device)
      formdata.append('start_date', this.start_date)
      formdata.append('end_date', this.end_date)
      formdata.append('progress', this.progress)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.title = ''
            this.type = ''
            this.alignment_and_motivation = false
            this.accompanying_and_synergy = false
            this.explanation_and_discussion = false
            this.text = ''
            this.title_attach = ''
            this.trustee_device = ''
            this.start_date = ''
            this.end_date = ''
            this.progress = ''

            this.allItems()
            this.resetItems()

          })
          .catch();
    },
    resetItems(){
      this.title = ''
      this.alignment_and_motivation = false
      this.accompanying_and_synergy = false
      this.explanation_and_discussion = false
      this.text = ''
      this.start_date = ''
      this.end_date = ''
      this.trustee_device = ''
      this.progress = ''
      this.id_item = ''
      this.is_update = false
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/support_measures_problems/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              this.allItems()
              toast.success(message)
              this.deleteModal = false


            }
          })
          .catch();
    },
    editMethod(id){
      this.is_update = true
      this.id_item = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/support_measures_problems/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const item = response.item


            this.is_update = true

            if (item){
              this.title = item.title
              this.alignment_and_motivation = item.alignment_and_motivation ? true : false
              this.accompanying_and_synergy = item.accompanying_and_synergy ? true : false
              this.explanation_and_discussion = item.explanation_and_discussion ? true : false
              this.text = item.text
              this.start_date = item.start_date
              this.end_date = item.end_date
              this.trustee_device = item.trustee_device
              this.progress = item.progress

            }
          })
          .catch();
    },
    deleteMethod(id){
      this.id_item = id
      this.deleteModal = true
    },
    docsMethod(title,id){
      this.titleDoc = title
      this.id =id
      this.allDocsMethod(this.id)

      this.documentsModal = !this.documentsModal

    },
    allDocsMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/all_docs/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
            })


          })
          .catch();
    },
    addDocs(){
      const file = this.$refs.fileInput.files[0]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach)
      formdata.append('file', file)
      formdata.append('id', this.id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/store_file`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.$refs.fileInput.value = ''
            this.title_attach = ''
            this.allDocsMethod(this.id)

          })
          .catch();



    },
    store(){

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title)
      formdata.append('type', this.type)
      formdata.append('alignment_and_motivation', this.alignment_and_motivation ? 1 : 0)
      formdata.append('accompanying_and_synergy', this.accompanying_and_synergy ? 1 : 0)
      formdata.append('explanation_and_discussion', this.explanation_and_discussion ? 1 : 0)
      formdata.append('text', this.text)
      formdata.append('title_attach', this.title_attach)
      formdata.append('trustee_device', this.trustee_device)
      formdata.append('start_date', this.start_date)
      formdata.append('end_date', this.end_date)
      formdata.append('progress', this.progress)
      formdata.append('file', JSON.stringify(this.documents))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.title = ''
            this.type = ''
            this.alignment_and_motivation = ''
            this.accompanying_and_synergy = ''
            this.explanation_and_discussion = ''
            this.text = ''
            this.title_attach = ''
            this.trustee_device = ''
            this.start_date = ''
            this.end_date = ''
            this.progress = ''

            this.allItems()

          })
          .catch();
    },
    allItems(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/support_measures_problems/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.status_seconder =false
            this.seconder_ban = false
            this.status_seconder_step = false
            this.approver_ban = false
            this.status_approver = false
            this.data_entry=response.data_entry
            this.type=response.type
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.AllItemList.length=0
            response.all.forEach((item)=>{
              this.AllItemList.push(item)
            })
            this.is_fetch = false
            this.setShow()
            if (!response.status_seconder){
              if (response.status){
                this.status_seconder = true
              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')){
              this.status_seconder = false
            }
            if (response.status && !response.status_approver){
              this.status_seconder = true
            }
            if (response.seconder_ban){
              this.seconder_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }
            if (response.approver_ban){
              this.approver_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }

            if (response.status_approver){
              this.status_approver = true
            }
            if (response.text_seconder){
              this.seconder_ban = true
              this.textAlert = response.text_seconder??'موردی یافت نشد'
            }
            if (parseInt(response.step)===1){
              this.status_seconder_step=true
              this.status_seconder=true
            }
            if (parseInt(response.step)===2){
              this.status_seconder_step=true
              this.status_seconder=false
            }  if (parseInt(response.step)===0){
              this.status_seconder_step=false

            }
            this.show_insert = response.status_insert

            if ((parseInt(response.step)===1&&this.type_two)||(parseInt(response.step)===2&&this.type_two) || (parseInt(response.step)===2&&this.type_one) || parseInt(response.step)===3){
              this.not_show = false
            }
          })
          .catch();
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },

    ProductivityPeriod(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status){
              this.isWrite = true
              return
            }else{
              this.isWrite = false
            }



          })
          .catch();
    },
  },
  mounted() {
    this.allItems()
    this.fetchItems()
    this.ProductivityPeriod()
  }

}
</script>

<style scoped>
label{
  font-size: 1vw;
}
</style>